import { Text } from '@tonic-one/react';
import React from 'react';

// convert number to percent with red/green color for <TableTemplate />
export default function Percent(props: { n: number | string }) {
  const n = typeof props.n === 'string' ? parseFloat(props.n) : props.n;
  const percent = (n * 100).toFixed(1);
  if (n < 0) {
    return <Text color="#04C45A">{percent}%</Text>;
  } else if (n > 0) {
    return <Text color="#F24C4F">{percent}%</Text>;
  } else {
    return <Text>-</Text>;
  }
}
